<template>
  <div class="sidebarOne-view">
    <div class="sidebarTop">
      党政图书
    </div>
    <ul class="list-view">
      <li class="list-li" v-for="(item,index) in list" :key="index" @click.stop="sidebarClick(item.id, item.text)">
        <div class="list-top">
          {{item.text}}
          <span class="shu"><i class="el-icon-arrow-right"></i></span>
        </div>
        <ol>
          <li v-for="(child,i) in item.children" :key="i" v-if="i < 2" @click.stop="sidebarClick(child.id, child.text)">
            <span v-if="i > 0"></span>
            {{child.text}}
          </li>
        </ol>
        <div class="children-view">
          <div class="children-content">
            <strong>全部分类</strong>
            <ul>
              <li v-for="(child,i) in item.children" :key="i" @click.stop="sidebarClick(child.id, child.text)">
                {{child.text}}
                <span></span>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'sidebarOne',
  data () {
    return {
      list: []
    }
  },
  methods: {
    sidebarClick (id, text) {
      // console.log(arguments)
      this.$router.push({
        name: 'Classification',
        params: {
          catId: id,
          text: text
        }
      })
    },
    getCatagory () { // 获取图书分类
      this.$get(this.$allUrl.getCatagory).then(res => {
        if (res.code === '0') {
          const list = res.data
          list.forEach(element => {
            if (element.child.length > 0) {
              let arr = []
              element.child.forEach(e => {
                arr.push({
                  id: e.catId,
                  text: e.catName
                })
              })
              this.list.push({
                id: element.catId,
                text: element.catName,
                children: arr
              })
            }
          })
        }
      })
    }
  },
  mounted () {
    this.getCatagory()
  }
}
</script>
<style lang="less" scoped>
  @fint-size: 14px;
  @width: 200px;
  @hoverColor: red;
  .sidebarOne-view{
    width: @width;
    ul{
      padding: 0;
      margin: 0;
      list-style: none;
    }
    .sidebarTop{
      background-color: #54536F;
      color: white;
      line-height: 40px;
      text-align: center;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .list-view{
      border-top: 2px dashed white;
      font-size: @fint-size;
      background-color: #7D74A2;
      .list-li{
        padding: 10px 5px;
        border-bottom: 1px solid #645B89;
        cursor: pointer;
        position: relative;
        .list-top{
          color: #D9D1F9;
          .shu{
            float: right;
          }
        }
        ol{
          padding: 0;
          margin: 0;
          list-style: none;
          display: flex;
          color: #FEFEFF;
          overflow: hidden;
          li{
            padding-right: 5px;
            // float: left;
            span{
              border-left: 1px solid #FEFEFF;
              display: inline-block;
              width: 1px;
              height: 10px;
            }
          }
          li:hover{
            color: @hoverColor;
          }
        }
        .children-view{
          width: 400px;
          border: 1px solid #6A6091;
          border-left: 0;
          position: absolute;
          z-index: 1000;
          left: @width;
          top: 0;
          padding: 10px 10px 0 10px;
          display: none;
          background-color: white;
          .children-content{
            display: flex;
            strong{
              color: #54536F;
              padding-right: 10px;
            }
            ul{
              flex: 1;
              li{
                padding: 0 10px 10px 0;
                float: left;
                span{
                  border-right: 1px solid black;
                  display: inline-block;
                  width: 1px;
                  height: 10px;
                  margin-left: 6px;
                }
              }
              li:hover{
                color: @hoverColor;
              }
            }
          }
        }
      }
      .list-li:hover{
        background: #6A6091;
      }
      .list-li:hover .list-top > .shu{
        display: none;
      }
      .list-li:hover .children-view{
        display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/base/sidebar1/sidebar1.vue